module.exports = __webpack_public_path__ + "img/24.87e16d21.jpg";